export default __webpack_public_path__ + "static/media/desktop_dr_00.421acc0d.png";